export const TYPES = {
  GET_PAYOUT_DAILY_REQUEST: "GET_PAYOUT_DAILY_REQUEST",
  GET_PAYOUT_DAILY_SUCCESS: "GET_PAYOUT_DAILY_SUCCESS",
};
